export enum SettingsTabsEnums {
  base = 'base',
  password = 'password',
  administration = 'administration'
}
